<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="{}"
      @submit="handleCreate"
    >
      <Property
        ref="propertyForm"
        :propTrendingTags="trendingTags"
      />
    </c-source-form>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { formColumns } from './columns';
import Property from './components/property';

@Component({
  components: { Property }
})
export default class ProductsNew extends Vue {

  categories = [];
  trendingTags = [];

  get columns() {
    return formColumns({ categories: this.categories })
  }

  async mounted() {
    const [{ data: categories }, trendingTags] = await Promise.all([
      this.$request.get('/categories', { params: { per_page: 100, simple_list: true } }),
      this.$request.get('/tags', { params: { taggable_type: 'Trending' } }),
    ]);
    this.categories = categories;
    this.trendingTags = trendingTags;
  }

  async handleCreate(data) {
    const propertyForm = this.$refs.propertyForm.submit();
    const body = {
      ...propertyForm,
      ...data,
      series_list: (data.series_list || []).join(','),
      category_ids: (data.category_ids || []).join(','),
      related_product_ids: data.related_products.map(item => item.id).join(',')
    }
    delete body.related_products;
    const { id } = await this.$autoLoading(
      this.$request.post('/products', body)
    );
    this.$message.success('新建成功');
    this.$router.push({ name: 'products.show', params: { id } });
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .c-source-form .content {
    width: 100%;
    max-width: 1000px;
  }
</style>
